export default __webpack_public_path__ + "static/slide-1-d07d31ecc4323001412ed75ef090e649.jpg";